export default "__VITE_ASSET__Df_NKQcS__"